import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
      {items.map((crumb, index) => (
        <span key={`${crumb.label}-${index}`} className="flex items-center gap-1">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {crumb.to && index < items.length - 1 ? (
            <Link to={crumb.to} className="hover:text-primary-600 transition-colors">
              {crumb.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{crumb.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}